import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '@services/config/config.service';
import {SearchResultsProcessor} from '@formbird/shared';
import {AvlCurrentLocationGmapComponentDefinition} from './avl-current-location-gmap.component.definition';
import {FormbirdInjectorService, SearchService} from 'formbird-services';
import {SclUtilAvlService, SclUtilGmapService} from 'formbird-sc-shared';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import * as GoogleMapsLoader from '../../../../formbird-mapping/src/lib/google/GoogleMapsLoader.js';
import * as moment from 'moment';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {ChangedDocumentService} from 'formbird-services';

// import { AvlTestData } from './avl-test-data';

@Component({
  templateUrl: './avl-current-location-gmap.component.html',
  styleUrls: [
    './avl-current-location-gmap.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvlCurrentLocationGmapComponent extends AbstractComponent<AvlCurrentLocationGmapComponentDefinition> implements OnInit {

  @ViewChild('targetMap', {static: false}) target: ElementRef;

  // services
  notificationService: any;
  dataService: any;
  loggedInUserService: any;

  //
  google;
  map;
  imageMarker = 'images/marker.png';
  id;
  tooltipConfig;
  timeOutDelay = 1000;
  targetMapElement;
  vehicleMainImageFileField;
  inActiveVehicle = 2;
  refreshInterval = 30;
  vehicleIconFileField;
  isFirstTime = true;
  markersMap = {};
  newVehicleID;
  titleTemplateOverrideId;
  refreshIntervalIds = [];
  geozonesQuery = '';
  geozonesData = '';
  geozonesName = '';
  apiKey = 'AIzaSyCcweDoZWu8Ve50pmGlErJ4a3JcFDO9dZc';
  isShowAvlVehicles = false;
  previousPopup;
  vehicleMarker;
  vehicles;

  constructor(
    public cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilGmapService: SclUtilGmapService,
    private sclUtilMapService: SclUtilMapService,
    private sclUtilAvlService: SclUtilAvlService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    private searchService: SearchService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);

    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
  }

  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);
    if (!(typeof this.componentDefinition.inActiveVehicle === 'undefined' || this.componentDefinition.inActiveVehicle === null)) {
      this.inActiveVehicle = this.componentDefinition.inActiveVehicle;
    }
    if (!(typeof this.componentDefinition.refreshInterval === 'undefined' || this.componentDefinition.refreshInterval === null)) {
      this.refreshInterval = this.componentDefinition.refreshInterval;
    }
    if (!(typeof this.componentDefinition.vehicleIconFileField === 'undefined' || this.componentDefinition.vehicleIconFileField === null)) {
      this.vehicleIconFileField = this.componentDefinition.vehicleIconFileField;
    }
    if (!(typeof this.componentDefinition.tooltipsTable === 'undefined' || this.componentDefinition.tooltipsTable === null)) {
      this.tooltipConfig = this.componentDefinition.tooltipsTable;
    }
    if (!(typeof this.componentDefinition.image === 'undefined' || this.componentDefinition.image === null)) {
      this.vehicleMainImageFileField = this.componentDefinition.image;
    }
    if (!(typeof this.componentDefinition.geozones === 'undefined' || this.componentDefinition.geozones === null)) {
      if (!(typeof this.componentDefinition.geozones.filter === 'undefined' || this.componentDefinition.geozones.filter === null)) {
        this.geozonesQuery = this.componentDefinition.geozones.filter;
      }
      if (!(typeof this.componentDefinition.geozones.data === 'undefined' || this.componentDefinition.geozones.data === null)) {
        this.geozonesData = this.componentDefinition.geozones.data;
      }
      if (!(typeof this.componentDefinition.geozones.name === 'undefined' || this.componentDefinition.geozones.name === null)) {
        this.geozonesName = this.componentDefinition.geozones.name;
      }
    }
    if (!(typeof this.componentDefinition.titleTemplateOverrideId === 'undefined'
     || this.componentDefinition.titleTemplateOverrideId === null)) {
      this.titleTemplateOverrideId = this.componentDefinition.titleTemplateOverrideId;
    }

    this.id = Math.floor(Math.random() * (1000 - 1)) + 1;

    const clientConfig = this.configService.clientConfig();
    if (clientConfig && clientConfig.googleMapsKey) {
      this.apiKey = clientConfig.googleMapsKey;
    }

    this.setShowVehicleList(this.isShowAvlVehicles);

    this.setupChangeDetection();

    const avlVehiclesFieldSub = this.changedDocumentService.watch(this.componentDefinition.avlVehiclesField
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch avlVehiclesField, value = ' + fieldValue);
        this.document[this.componentDefinition.avlVehiclesField] = fieldValue;
        this.watchAvlVehiclesField(fieldValue);
    });
    this.subs.add(avlVehiclesFieldSub);

    this.loadMap(() => {
      console.log('GoogleMapsLoader loaded');

      if (typeof this.componentDefinition.heightNum === 'undefined' || this.componentDefinition.heightNum === null) {
        this.target.nativeElement.style.height = '180 px';
      } else {
        let height = 180 * this.componentDefinition.heightNum;
        const docHeight = document.body.scrollHeight;
        if (height > (docHeight - 180)) {
          height = docHeight - 180;
        }
        this.target.nativeElement.style.height = '' + height + 'px';
      }

      const uluru = {lat: -25.344, lng: 131.036};
      this.map = new this.google.maps.Map(this.target.nativeElement, {zoom: 4, center: uluru});
      // begin create overlayview
      const overlay = new this.google.maps.OverlayView();
      overlay.onAdd = () => {
        overlay.getPanes().markerLayer.id = 'markerLayer';
        // var markersView = document.getElementById("markerLayer");
        // var callback = markersChange;
        // var observer =  new MutationObserver(callback);
        // var configObserver = {  childList: true};
        // observer.observe(markersView,configObserver);

        // markersView.addEventListener("DOMNodeInserted", markersChange, false);
      };
      overlay.setMap(this.map);
      // end create overlayview
      this.map.addListener('zoom_changed', this.markersChange.bind(this));
      this.map.addListener('dragstart', this.markersChange.bind(this));
      this.map.addListener('click', () => {
        if (this.previousPopup) {
          this.previousPopup.close();
        }
      });

      const MapLabel = this.sclUtilGmapService.initMapLabel(this.google);
      if (this.geozonesQuery && this.geozonesData) {
        const options = this.sclUtilMapService.constructQueryGeoZones(this.geozonesQuery, this.template);   // testing
        this.searchService.search(options).then((data) => {
          this.sclUtilGmapService.getGeoCoors(SearchResultsProcessor, data, this.geozonesData, this.geozonesName, this.google
            , (geozones) => {
              if (geozones && geozones.length) {
                for (let i = 0 ; i < geozones.length; i++) {
                  const geozone = geozones[i];
                  if (geozone.shape === 'Point') {
                    const mapLabel: any = new MapLabel({
                        text: geozone.name,
                        position: geozone.coors[0],
                        map: this.map,
                        fontSize: 20
                    });
                    const marker = new this.google.maps.Marker({
                      position: geozone.coors[0]
                    });
                    marker.setMap(this.map);
                  } else if (geozone.shape === 'Line') {
                    if (this.geozonesName) {
                      const textCoor = this.centerOfZone(geozone.coors);
                      const mapLabel = new MapLabel({
                          text: geozone.name,
                          position: textCoor,
                          map: this.map,
                          fontSize: 20
                      });
                    }
                    const polyline = new this.google.maps.Polyline({
                      path: geozone.coors,
                      editable: false,
                      strokeColor: '#FF0000',
                      strokeOpacity: 1.0,
                      strokeWeight: 2
                    });
                    polyline.setMap(this.map);
                  } else if (geozone.shape === 'Polygon') {
                    if (this.geozonesName) {
                      const textCoor = this.centerOfZone(geozone.coors);
                      const mapLabel = new MapLabel({
                          text: geozone.name,
                          position: textCoor,
                          map: this.map,
                          fontSize: 20
                      });
                    }
                    const polyline = new this.google.maps.Polygon({
                      path: geozone.coors,
                      editable: false,
                      strokeColor: '#FF0000',
                      strokeOpacity: 1.0,
                      strokeWeight: 2
                    });
                    polyline.setMap(this.map);
                  } else {
                    console.log('not handles yet!!!');
                  }
                }
              } else {
                console.log('geozones undefined');
              }
          });
        });
      }


      if (!(typeof this.componentDefinition.avlVehiclesField === 'undefined'
      || this.componentDefinition.avlVehiclesField === null)) {
        const vehicles = this.document[this.componentDefinition.avlVehiclesField];
        this.getListVehicleData(vehicles);
      } else {
        this.document[this.componentDefinition.avlVehiclesField] = {};
      }
      setInterval(this.markersChange.bind(this), 1000);

    }); // end loadMap

  }


  loadMap(cb) {
    // this.apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // avl-dev server
    this.apiKey = 'AIzaSyDLF3KfOk7figOYUQAudATOTTqCbzf1ylc'; // localhost:3000
    GoogleMapsLoader.KEY = this.apiKey;
    GoogleMapsLoader.LIBRARIES = 'places';
    GoogleMapsLoader.SENSOR = true;
    GoogleMapsLoader.load((google) => {
      this.google = google;
      cb();
    });
  }

  watchAvlVehiclesField(value) {
    console.log('watchAvlVehiclesField, value = ' + value);
    const tempVehicles = this.document[this.componentDefinition.avlVehiclesField];
    if (this.vehicles && tempVehicles && tempVehicles.length === this.vehicles.length + 1 ) {
      this.newVehicleID = null;
      for (let i = 0; i < tempVehicles.length; i++) {
        const index = this.vehicles.indexOf(tempVehicles[i]);
        if (index < 0) {
          this.newVehicleID = tempVehicles[i].documentId;
          break;
        }
      }
    }
    this.vehicles = tempVehicles;
    this.getListVehicleData(this.vehicles);
  }
  centerOfZone(coordinates) {
    let lat = 0;
    let lng = 0;
    if (coordinates.length <= 0) {
      return;
    }
    for (let i = 0; i < coordinates.length; i++) {
      lat = lat + coordinates[i].lat();
      lng = lng + coordinates[i].lng();
    }
    return new this.google.maps.LatLng(lat / coordinates.length, lng / coordinates.length);
  }

  setShowVehicleList(val) {
    for (const id in this.template.components) {
      if (this.template.components.hasOwnProperty(id)) {
        const comp: any = this.template.components[id];
        if (comp.name === this.componentDefinition.avlVehiclesField) {
          comp.visible = val;
        }
      }
    }
  }
  getListVehicleData(vehicles) {
    // refreshIntervalIds will be reset to clear auto request lastevent
    if (this.refreshIntervalIds && this.refreshIntervalIds.length > 0) {
      for (let i = 0; i < this.refreshIntervalIds.length; i++) {
        clearInterval(this.refreshIntervalIds[i]);
      }
    }
    this.refreshIntervalIds = [];

    for (const id in this.markersMap) {
      if (this.markersMap.hasOwnProperty(id)) {
        let index = -1;
        for (let i = 0; i < vehicles.length; i++) {
          if (vehicles[i].documentId === id) {
            index = i;
            break;
          }
        }

        if (index < 0) {
          this.markersMap[id].setMap(null);
          delete  this.markersMap[id];
        }
      }
    }


    if (vehicles != null && vehicles.length > 0) {
      for (let i = 0; i < vehicles.length; i++) {
        const vehicle = vehicles[i];

        const options = this.sclUtilMapService.constructQueryDocument([vehicle.documentId], this.document);
        this.searchService.search(options).then( (result) => {
          if (result && result.length > 0) {
            console.log('Vehicle Data:');
            console.log(result);
            this.addPointer(vehicle, result[0]._source);
          }
        }, (err) => {
          console.error('error options when getting vehicles data :' + options.filter);
          console.error(err);
        });

      }

    }
  }
  addPointer(avlDevice, vehicleData) {
    // var imei = avlDevice.imei;
    const deviceName = avlDevice.name; // avlDevice.deviceName;
    const documentId = avlDevice.documentId;
    vehicleData.imgUrl = this.imageMarker;
    // if(vehicleData[scope.tplItem.vehicleFullNameField])
    //     deviceName = vehicleData[scope.tplItem.vehicleFullNameField];

    if (avlDevice.imageFileNo) {
        vehicleData.imgUrl = '/api/getFile/' + avlDevice.imageFileNo;
    }

    if (this.vehicleIconFileField && vehicleData && vehicleData[this.vehicleIconFileField]
        && Array.isArray(vehicleData[this.vehicleIconFileField]) && vehicleData[this.vehicleIconFileField].length > 0) {

        const imageData = vehicleData[this.vehicleIconFileField][0];
        vehicleData.imgUrl = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
    }

    const intervalID = setInterval( () => this.getLastEventOfVehicle(vehicleData, deviceName, documentId), this.refreshInterval * 1000);
    this.refreshIntervalIds.push(intervalID);
    this.getLastEventOfVehicle(vehicleData, deviceName, documentId);
  }
  getLastEventOfVehicle(vehicleData, deviceName, documentId) {
    const params = {
      functionName: 'getLastEvent1',
      componentDocumentName: 'sc-avl-current-location-gmap',
      functionParameters: [this.componentDefinition.dataService, documentId]
    };
    this.httpClient.post('api/execute', params).subscribe( (dataResult: any) => {
      const datas = dataResult;
      console.log('Last event is: ' + datas);
      console.log(datas);

      if (datas && datas.length > 0) {
        const item = datas[0];

        // var valJson = scope.sclUtilMap.parseAVLData(item);
        const feature = item.locationGeo.features[0];
        const properties = feature.properties;

        const currentDate = new Date();
        const newEventDate = new Date(item.eventDate);

        const obj: any = {};
        obj.id = item._id;
        // obj.imei = item.imei[0];
        obj.longitude = item.locationGeo.features[0].geometry.coordinates[0];
        obj.latitude = item.locationGeo.features[0].geometry.coordinates[1];
        obj.speedKPH = item.speedKPH;
        obj.heading = item.heading;
        obj.eventDate = item.eventDate;
        obj.address = ''; // TO DO : parse when getting json
        // check if last avl event is too old
        if ((currentDate.getTime() - newEventDate.getTime()) / 1000 / 60 >  60 * this.inActiveVehicle) {
            obj.color = '#000000';
        }

        this.showMap(obj, vehicleData, deviceName, documentId);
        if (this.isFirstTime) {
          this.isFirstTime = false;
          this.map.setCenter({lat: obj.latitude, lng: obj.longitude});
          this.map.setZoom(12);
        } else if (this.newVehicleID && documentId === this.newVehicleID) {
          this.map.panTo({lat: obj.latitude, lng: obj.longitude});
          this.newVehicleID = null;
        }

      }
    }, (err) => {
      console.error('error query current location :');
      console.error(err);
    });
  }

  formatTime(time) {
    const  longDate = 'MMM DD YYYY, h:mm:ss a';
    const timeReturn = moment(time).fromNow() + ' (' + moment(time).format(longDate) + ')';
    return timeReturn;
  }
  toDataRow(col1, col2) {
    const row: any = {};
    row.col1 = col1;
    row.col2 = col2;
    return row;
  }
  tableHtml(array) {
    const style = '';
    let tableText = '<table style="width:100%">';
    for (let i = 0; i < array.length; i++) {
      tableText += '<tr>';
      tableText += '<td>' + array[i].col1 + '</td>';
      tableText += '<td>' + array[i].col2 + '</td>';
      tableText += '</tr>';
    }
    tableText += '</table>';
    return tableText;
  }
  showMap(data, vehicleData, deviceName, documentId) {
    let url = '';
    let name = '';
    if (documentId) {
      url = 'form/' + documentId ;
      if (this.titleTemplateOverrideId) {
        url += ('/' + this.titleTemplateOverrideId);
      }
    }

    let tooltipImg = '/api/getFile/562b8d70-5eb0-11e8-9d98-e5cdc65a95c1/garbage-truck.jpg';
    let imgtooltip = '';

    if (this.vehicleMainImageFileField && vehicleData[this.vehicleMainImageFileField]
        && Array.isArray(vehicleData[this.vehicleMainImageFileField])
        && vehicleData[this.vehicleMainImageFileField].length > 0) {

      const imageData = vehicleData[this.vehicleMainImageFileField][0];
      tooltipImg = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
      imgtooltip = '<img src=' + tooltipImg + '/>';
    } else  {
      imgtooltip = '';
    }

    if (deviceName) {
      name = '<div><a style="color:#2d24ff" href="' + url + '"><b>Vehicle: ' + deviceName + '</b></a></div>';
    }
    const pointFeature: any = {};
    const rotation =  data.heading; // * Math.PI / 180.0 // rotation is in radian;

    console.log('heading: ' + data.heading + ' degree');


    const addressRow = this.toDataRow('Address', '');
    const eventDate = new Date(data.eventDate);
    const timeFormat = this.formatTime(eventDate);
    const dateRow = this.toDataRow('Date', timeFormat);
    const speedRow = this.toDataRow('Speed', data.speedKPH);
    const headingRow = this.toDataRow('Heading', data.heading);
    const imageRow = this.toDataRow('Image', imgtooltip);

    const arrayValue = [];
    arrayValue.push(addressRow);
    arrayValue.push(dateRow);
    arrayValue.push(speedRow);
    arrayValue.push(headingRow);

    if (this.tooltipConfig) {
      for (const key1 in this.tooltipConfig) {
        if (this.tooltipConfig.hasOwnProperty(key1)) {
          const key2 = this.tooltipConfig[key1];
          let value = this.sclUtilMapService.parseHandlerBar(key2, vehicleData) ;
          value = value ? value : '';
          const tooltipRow = this.toDataRow(key1, value);
          arrayValue.push(tooltipRow);
        }
      }
    }

    arrayValue.push(imageRow);
    const tooltip = name + this.tableHtml(arrayValue);


    pointFeature.properties = {
      url: url,
      address: tooltip,
      name: deviceName,
      icon: vehicleData.imgUrl,
      color: data.color,
      rotation: rotation
    };


    let marker;
    if (this.markersMap[documentId]) {
      marker = this.markersMap[documentId];
      marker.infoWindow.setContent(tooltip);
      console.log('Set tooltip ' + tooltip);
      marker.setPosition({lat: data.latitude, lng: data.longitude});
      marker.rotation = rotation;
      this.changeMarkerRotation(marker, rotation);
    } else {

      const icon = {
        url: vehicleData.imgUrl,
        labelOrigin: new this.google.maps.Point(40, 70)
      };


      marker = new this.google.maps.Marker({
        map: this.map,
        icon: icon,
        label: {
            text: vehicleData[this.componentDefinition.vehicleShortNameField],
            fontWeight: 'bold',
            fontSize: '16px',
            fontFamily: '"Courier New", Courier,Monospace',
            color: 'black'
        }
      });

      const width = this.target.nativeElement.offsetWidth / 10 * 6;
      // width = Math.min(width, 300);

      const infoWindow = new this.google.maps.InfoWindow({
          content: tooltip,
          maxWidth: width
      });
      console.log('Create tooltip ' + tooltip);

      marker.infoWindow = infoWindow;
      marker.addListener('click', () => {
        if (this.previousPopup) {
          this.previousPopup.close();
        }
        marker.infoWindow.open(this.map, marker);
        this.previousPopup = marker.infoWindow;
      });
      marker.rotation = rotation;
      this.markersMap[documentId] = marker;

    }
    this.convertGPSToAddress( data.latitude, data.longitude, (result) => {
      console.log('convertGPSToAddress');
      console.log(result);
      const temp: any = {properties: {}};
      const address = this.sclUtilMapService.fillGoogleAddress(result.data.results[0], temp);
      console.log('address: ');
      console.log(address);
      let text = (address.properties.streetNo) ? address.properties.streetNo : '';
      text += ' ' + ((address.properties.street) ? address.properties.street : '');
      text += '<br>' + ((address.properties.suburb) ? address.properties.suburb  : '');
      text += ', ' + ((address.properties.state) ? address.properties.state : '');
      text += ', ' + ((address.properties.country) ? address.properties.country : '');

      addressRow.col2 = text;
      const arrayValue1 = [];
      arrayValue1.push(addressRow);
      arrayValue1.push(dateRow);
      arrayValue1.push(speedRow);
      arrayValue1.push(headingRow);

      if (this.tooltipConfig) {
        for (const key1 in this.tooltipConfig) {
          if (this.tooltipConfig.hasOwnProperty(key1)) {
            const key2 = this.tooltipConfig[key1];
            let value = this.sclUtilMapService.parseHandlerBar(key2, vehicleData) ;
            value = value ? value : '';
            const tooltipRow = this.toDataRow(key1, value);
            arrayValue1.push(tooltipRow);
          }
        }
      }

      arrayValue1.push(imageRow);
      const tooltip1 = name + this.tableHtml(arrayValue1);
      console.log('Set tooltip ' + tooltip1);
      marker.infoWindow.setContent(tooltip1);
    });
    marker.setPosition({lat: data.latitude, lng: data.longitude});

  }
  convertGPSToAddress(lat, lon, cb) {

    const link = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + this.apiKey;
    this.httpClient.get(link).subscribe((data: any) => {
        if (data.status === 'OK' ) {
          if (cb && typeof cb === 'function') {
            cb(data);
          }
        } else {
          console.log('Error: ' + data.error_message);
          cb(null);
        }
    }, error => {
      console.log('Error : ' + error);
      cb(null);
    });
  }
  mapUpdateWidth() {
    const value = this.target.nativeElement.offsetWidth;
    const width = value / 10 * 6;
    for (const key in this.markersMap) {
        if (this.markersMap[key].infoWindow) {
          this.markersMap[key].infoWindow.maxWidth = width;
        }
    }
  }
  markersChange() {
    const markersLoading = [];
    for (const key in this.markersMap ) {
      if (!this.isVisible( this.markersMap[key].img) ) {
        markersLoading.push(this.markersMap[key]);
      }
    }

    if (markersLoading.length > 0) {
      console.log(document.querySelectorAll('#markerLayer img'));
      const listImgElement = document.querySelectorAll('#markerLayer img');


      for (let i = 0; i  < listImgElement.length; i++) {
        const element: any = listImgElement[i];
        for (const key in markersLoading ) {
            if (element.__src__ === markersLoading[key].icon.url && !element.id) {
              element.id = 'marker' + key;
              element.style.transform = 'rotate(' + markersLoading[key].rotation + 'deg)';
              markersLoading[key].img = element;
              if (markersLoading[key].rotation) {
                this.changeMarkerRotation(markersLoading[key], markersLoading[key].rotation);
              }
            }
        }
      }
    }
  }
  changeMarkerRotation(marker, rotation) {
    let element = marker.img;
    if (!rotation) {
      return;
    }
    if (!this.isVisible(element)) {
      //  markersChange();
      element = marker.img;
    }
    if (this.isVisible(element) ) {
      if (marker.icon.size) {
        marker.icon.anchor = new this.google.maps.Point(marker.icon.size.width / 2, marker.icon.size.height / 2);
      }
      element.style.transform = 'rotate(' + rotation + 'deg)';
    }
    marker.rotation =  rotation;
  }
  isVisible(element) {
    if (element && element.offsetParent) {
      return true;
    }
    return false;
  }


  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
